import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material/styles";

export const useStyle = makeStyles()((theme: Theme) => ({
    // A bare flex column, not a scroll container: scrolling belongs to the individual PaneTabPanel,
    // so that a tab whose main content is a table can hand its height down and let the table own
    // the scrollport (same contract as the full-page tables).
    contentBox: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor:
            theme.palette.mode === "dark"
                ? theme.palette.emteria.background.listHover
                : theme.palette.emteria.background.paperDeep,
    },
    buttonBox: { display: "flex", gap: theme.spacing(1) },
    footerButtonBox: { display: "flex", justifyContent: "flex-end", paddingTop: theme.spacing(4) },
    loadingBox: { height: "100vh", margin: 0, display: "flex", justifyContent: "center", alignItems: "center" },
    fetchErrorBox: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: theme.spacing(2),
        textAlign: "center",
    },
    panelTitle: { fontWeight: 700 },
    panelSubtitle: {
        color: theme.palette.emteria.text.secondary,
        marginTop: theme.spacing(0.5),
    },
    licenseSummaryIndicator: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        borderRadius: "50%",
        borderColor: theme.palette.emteria.border.primary,
        borderWidth: 1,
        borderStyle: "solid",
    },
    headerBox: { display: "flex", flexDirection: "column", alignItems: "flex-start" },
    licenseSummaryBox: { display: "flex", flexDirection: "row", alignItems: "center", gap: theme.spacing(1) },
}));
